//
//
//

export default {
  name: 'MobileComponent',
};
